import catalog from 'apis/catalog';

import type { RawOptionGroupAPIData } from './option_groups.types';

export const allByTemplateId = async (id: number) => {
  const { data } = await catalog.get<RawOptionGroupAPIData[]>(`/options.json?template_id=${id}`);
  return data;
};

export const orderOptionGroups = async () => {
  const { data } = await catalog.get<RawOptionGroupAPIData[]>('/order_option_groups.json');
  return data;
};
